export const environment = {
  production: false,
  ROOT: '/',
  ENV_NAME: 'staging',
  AUTHORITY_DOMAIN: 'wintersnowb2c.b2clogin.com',
  CLIENT_ID: '61d1eae3-81f4-4c57-bb88-9f5d90285da6',
  SIGNUP_SIGNIN_AUTHORITY:
    'https://wintersnowb2c.b2clogin.com/stg-account.ecolab.com/B2C_1A_Connect_OIDC_SIGNIN',
  ELASTIC_APM_SERVER_URL:
    'https://231426ea0b784324aa2a5747fcae8dc6.apm.eastus2.azure.elastic-cloud.com:443',
  ONECUSTOMER_BASE_URL: 'https://stg-onecustomer-api.ecolab.com',
  DOTNET_SCOPE_READ: 'https://stg-account.ecolab.com/1C_Api_stg/1C.Read',
  DOTNET_SCOPE_WRITE: 'https://stg-account.ecolab.com/1C_Api_stg/1C.Write',
  ECOLAB_WEB: 'https://dotcom-stage-cds.ecolab.com/',
  API_DOTNET_TVD_Logout_URL: '/globalpreferences/user/logout',
  DATA_EDITOR_SERVICE: {
    READ_SCOPE: `https://stg-account.ecolab.com/EDE_Api_stg/EDE.Read`,
    WRITE_SCOPE: `https://stg-account.ecolab.com/EDE_Api_stg/EDE.Write`,
    BASE_URL: `https://potential-apim-001-s.azure-api.net`,
  },
  CDM_SERVICE: {
    READ_SCOPE: `https://stg-account.ecolab.com/c50d0237-50b4-409e-aecf-50e458b77de3/read.only`,
    BASE_URL:
      'https://api-cloudhubcentral-st.ecolab.com/user-reg-and-alignment',
  },
};
